import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UtilsService} from '../../core/services/utils/utils.service';
import {Entity} from '../../core/models/entities/entity';
import {DashboardService} from '../dashboard.service';
import {User} from '../../core/models/user';
import {Router} from '@angular/router';

export interface Quote {
  createdAt: number;
  updatedAt: number;
  id: string;
  person_id: string;
  quoteBy: QuoteBy;
  type: string;
  famous_quote: string;
  status: string;
  byAdmin: boolean;
  addedBy: any;
}

export interface QuoteBy {
  name: string;
}

export interface Survey {
  questions: Question[];
  createdAt: number;
  updatedAt: number;
  id: string;
  title: string;
  startDate: number;
  endDate: number;
  status: 'pending' | 'published' | 'paused' | 'closed';
  resultAnnounced: boolean;
}

export interface Question {
  createdAt: number;
  updatedAt: number;
  id: string;
  question: string;
  options: Option[];
  survey: string;
}

export interface Option {
  option: string;
}

@Component({
    selector: 'app-banners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.css'],
    standalone: false
})
export class BannersComponent implements OnInit {

  loading = false;
  bannersList = [];
  iconPayload = {
    icons: {
      bhakt: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg',
      vishvaguru: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg'
    }
  };
  uploadIconType: 'BHAKT' | 'VISHWAGURU';

  // IMAGE UPLOAD
  modalRef: BsModalRef;
  imageChangedEvent: any = '';
  croppedFile: any;
  aspectRatio = 1;

  option: string;
  pageLoading = true;
  loaders = Array(10).fill(0);

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private utils: UtilsService,
              private router: Router,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
    this.getBannersList();
  }

  uploadBanner(banner): void {
    this.api.addBanner({banner}).subscribe(response => {
      this.bannersList.push(response.imagePath);
      this.loading = false;
      this.toastr.success('Banner added successfully!');
      this.getBannersList();
    }, err => {
      this.loading = false;
      this.toastr.error(err.error.message);
    });
  }

  getBannersList(): void {
    this.api.getBanners().subscribe(res => {
      this.bannersList = res;
      this.pageLoading = false;
    }, (err => {
      this.pageLoading = false;
    }));
  }

  deleteBanner(i: number): void {
    if(confirm('Do you want to delete this banner?')) {
      this.api.deleteBanner(this.bannersList[i].id).subscribe(res => {
        this.toastr.success('Banner Deleted Successfully!');
        this.getBannersList();
      }, err => this.toastr.error(err.error.message));
    }

  }

  // IMAGE CROPPER
  fileChangeEvent(event: any, template: TemplateRef<any>, type): void {
    this.modalRef = this.modalService.show(template);
    this.aspectRatio = (type === 'BANNER' ? 2 : 1);
    this.imageChangedEvent = event;
    this.uploadIconType = type;
  }

  handleClickUpload(): void {
    const ele = document.getElementById('dp');
    if (!!ele) {
      ele.click();
    }
  }

  uploadImage(file): void {
    this.loading = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        if (this.uploadIconType === 'BHAKT') {
          this.iconPayload.icons.bhakt = res.response.url;
        } else if (this.uploadIconType === 'VISHWAGURU') {
          this.iconPayload.icons.vishvaguru = res.response.url;
        } else {
          this.uploadBanner(res.response.url);
        }
        this.loading = false;
      }, err => {
        this.loading = false;
      });
    };
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedFile = new File([base64ToFile(event.base64)], `${Date.now()}.png`);
  }

  loadImageFailed(): void {
    this.utils.toastError('Image Load failed!');
  }
}
